import { faBookOpen } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PropTypes from "prop-types";
import React, { Component } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { FormattedMessage } from "react-intl";
import * as uuid from "uuid";
import AddQuestionFromLibraryTable from "./AddQuestionFromLibraryTable";
import QuestionLibraryModel from "./QuestionLibraryModal";

/**
 *Component which represents a modal for adding question to library
 */
class PrivateQuestionLibrarySurveyEditor extends Component {
  constructor(props) {
    super(props);
    this.onButtonClick = this.onButtonClick.bind(this);
  }

  onButtonClick(name, value) {
    const { changeProperty } = this.props;
    changeProperty(name, value);
  }

  render() {
    const {
      getPrivateQuestionLibrary,
      showModalAddQuestionFromLibrary,
      showModalQuestionMyLibrarySettings,
      questionName,
      questionLibrary,
      addQuestionToTemplate,
      questionsToAdd,
      submitAdding,
      surveyLanguageForQuestionLibrary,
      changeProperty,
      addQuestionToMyLibrary,
      templateLanguages,
      surveyName,
      surveyIdentifier,
      surveyVersion,
      surveyQuestionIds
    } = this.props;

    return (
      <>
        <Button className="text-start" onClick={() => getPrivateQuestionLibrary()}>
          <FontAwesomeIcon icon={faBookOpen} className="me-2" />
          <FormattedMessage id="question.library.toolbox.my" />
        </Button>
        <QuestionLibraryModel
          showModalQuestionLibrarySettings={showModalQuestionMyLibrarySettings}
          showModalAddQuestionFromLibrary={showModalAddQuestionFromLibrary}
          questionName={questionName}
          surveyName={surveyName}
          surveyIdentifier={surveyIdentifier}
          surveyVersion={surveyVersion}
          questionId={uuid.v4()}
          surveyLanguageForQuestionLibrary={surveyLanguageForQuestionLibrary}
          questionLibrary={questionLibrary}
          templateLanguages={templateLanguages}
          questionsToAdd={questionsToAdd}
          changeProperty={changeProperty}
          addQuestionToLibrary={addQuestionToMyLibrary}
          getQuestionLibrary={getPrivateQuestionLibrary}
          addQuestionToTemplate={addQuestionToTemplate}
          submitAdding={submitAdding}
          questionSync={undefined}
          target={"settings"}
        />
        <Modal
          size="xl"
          show={showModalAddQuestionFromLibrary}
          onHide={() => this.onButtonClick("showModalAddQuestionFromOldLibrary", false)}
          scrollable
        >
          <Modal.Header closeButton>
            <Modal.Title>
              <FormattedMessage id="survey.editor.add.question.library.title.my" />
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <AddQuestionFromLibraryTable
              questionLibrary={questionLibrary}
              addQuestionToTemplate={addQuestionToTemplate}
              questionsToAdd={questionsToAdd}
              surveyQuestionIds={surveyQuestionIds}
            />
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => this.onButtonClick("showModalAddQuestionFromOldLibrary", false)}>
              <FormattedMessage id="app.common.Close" />
            </Button>
            <Button variant="primary" disabled={!questionsToAdd?.length} onClick={() => submitAdding()}>
              <FormattedMessage id="library.insertSelected" />
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }
}

PrivateQuestionLibrarySurveyEditor.propTypes = {
  showModalQuestionMyLibrarySettings: PropTypes.bool,
  showModalAddQuestionFromLibrary: PropTypes.bool,
  questionName: PropTypes.string,
  surveyName: PropTypes.string,
  surveyIdentifier: PropTypes.string,
  surveyVersion: PropTypes.number,
  surveyLanguageForQuestionLibrary: PropTypes.object,
  questionLibrary: PropTypes.array,
  templateLanguages: PropTypes.array,
  questionsToAdd: PropTypes.array,
  changeProperty: PropTypes.func,
  addQuestionToMyLibrary: PropTypes.func,
  getPrivateQuestionLibrary: PropTypes.func,
  addQuestionToTemplate: PropTypes.func,
  submitAdding: PropTypes.func
};

export default PrivateQuestionLibrarySurveyEditor;
